import Repository from "@/services/Repository";

export default {
  getCategory(id) {
    return Repository.get(`/latest/universe/categories/${id}`);
  },
  getGroup(id) {
    return Repository.get(`/latest/universe/groups/${id}`);
  },
  getType(id) {
    return Repository.get(`/latest/universe/types/${id}`, { headers: { "Accept-Language": "en-us" } });
  }
};
